import {
  type ApiRoleStrategy,
  ROLES,
  api,
  stringifyQueryObj,
  useQuery,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import type { sourcesEnum } from "../AdherentOrdersList/adherentOrdersReferential"

const categoryEnum: keyof typeof sourcesEnum = "SDAV"
export const useOrderPageApi = ({
  itemId,
  year,
}: { itemId: number; year: number; adherentId?: string }) => {
  const { endpoint: orderPageEndpoint, queryKey: orderPageQueryKey } = useRoleConf(
    orderPageApiRoleConf(categoryEnum),
  )

  const orderPageQueryParams = stringifyQueryObj({ year })

  // Order page
  const { data: orderPage, isLoading } = useQuery({
    queryKey: [...orderPageQueryKey, year],
    queryFn: () =>
      api.get<CategoryReferential>(`${orderPageEndpoint}?${orderPageQueryParams}`),
    select: (data) => data.orderPages?.find((page) => page.itemId === itemId),
  })

  return {
    orderPage,
    isLoading,
  }
}

interface CategoryReferential {
  orderPages?: OrderPage[] // only for SDAV orders
}

interface OrderPage {
  itemId: number // to match with ChallengeHistory.descriptionItem.id
  startIndex: number
  endIndex: number
}

const commonOrderPageApiRoleConf = (categoryEnum: string) => ({
  endpoint: `/api/loyalties/referential/category/${categoryEnum}`,
  queryKey: ["loyalties", "referential", "category", categoryEnum],
})

const orderPageApiRoleConf = (categoryEnum: string): ApiRoleStrategy => ({
  [ROLES.ADHERENT_HOLDER]: commonOrderPageApiRoleConf(categoryEnum),
  [ROLES.ADMIN]: commonOrderPageApiRoleConf(categoryEnum),
  [ROLES.ADHERENT_ADVISOR]: commonOrderPageApiRoleConf(categoryEnum),
})
